import { useState, useEffect } from 'react';
import memoService from "../services/memoService";
function useMemoCategories() {
    const [categories, setCategories] = useState([]);
    const { getCategories } = memoService;

    const getAllCategories = async () => {
        let [response, error] = await getCategories()
        if (error !== null) {
            console.log(error);
            return;
        }
        
        setCategories(setUpCategories(response));
    }

    const setUpCategories = (_categories) => _categories.map(category => {
        return {
            value: category.id,
            text: <span style={{ maxWidth: "200px" }}><i style={{ marginLeft: '10px', color: category.color }} className={category.icon}></i> </span>
        }
    })

    const addFirstRow = (row) =>{
        setCategories(data => [row,...data]);
    }
    useEffect(() => {
        getAllCategories();
    }, [])

    return { categories,addFirstRow };
}

export default useMemoCategories;